'use client';

import dynamic from 'next/dynamic';

export const BlocksInline = dynamic(() => import('./BlocksInline'));
